import { BalanceContext } from '@app/collections/fortress/BalanceContext'
import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Col, Divider, Row, Spacer, Text, useForm } from '@app/components'
import useFee from 'libs/services/hooks/useFee'
import React, { useContext, useEffect, useState } from 'react'

import { AmericanFlagIcon } from '~public'

import { PaymentMethodCollapse } from './payment-method/PaymentMethodCollapse'
import { WithdrawSummary } from './summary'
import { USDCInput } from './usdc-input'

export const OffRampDrawer: React.FC<{ isForDrawer?: boolean }> = () => {
  const [wireTransactionType, setWireTransactionType] = useState('wire-instructions-intl')
  //const [hifiTransactionType, setHifiTransactionType] = useState('hifi-instructions')
  const [fund, setFund] = useState('')
  const [selectedPanel, setSelectedPanel] = useState('')
  const { balance, fetchAccounts } = useContext(BalanceContext)

  const [selectedMethod, setSelectedMethod] = useState<any>({ name: '', description: '', fund: '' })

  // Input states (Pay and Receive)
  const [payAmount, setPayAmount] = useState(0)
  const [payType, setPayType] = useState('USD')

  const [receiveAmount, setReceiveAmount] = useState(0)
  const [receiveType, setReceiveType] = useState('USD')
  const { fetchUserInfo } = useContext(UserInfoContext)

  useEffect(() => {
    fetchUserInfo()
  }, [])

  const [form] = useForm()
  const [achForm] = useForm()

  const fee = useFee()

  return (
    <>
      <Row gutter={[10, 10]}>
        {process.env.NEXT_PUBLIC_WITHDRAW_ON == 'true' && (
          <>
            <Spacer value={10} />
            <Col span={24}>
              <Row style={{ rowGap: '45px', columnGap: '45px' }}>
                <Col span={24}>
                  <Row justify={'space-between'}>
                    <Col>
                      <Text>Digital Account</Text>
                    </Col>
                  </Row>
                  <Divider style={{ marginTop: 0 }} />
                  <Row gutter={[10, 10]}>
                    <Col>
                      <AmericanFlagIcon />
                    </Col>
                    <Col>
                      <Text>Current Balance</Text>
                      <Spacer value={1} />
                      <Text type="secondary">{balance} USD</Text>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <USDCInput
                    pay={{ amount: payAmount, setAmount: setPayAmount, type: payType, setType: setPayType }}
                    receive={{
                      amount: receiveAmount,
                      setAmount: setReceiveAmount,
                      type: receiveType,
                      setType: setReceiveType,
                    }}
                    balance={balance}
                    fee={fee}
                    selectedMethod={selectedMethod}
                    selectedPanel={selectedPanel}
                    wireTransactionType={wireTransactionType}
                  />
                </Col>

                <Col span={24}>
                  <Text>Select withdraw method</Text>
                </Col>
                <Col span={24}>
                  <PaymentMethodCollapse
                    fund={fund}
                    setFund={setFund}
                    selectedPanel={selectedPanel}
                    setSelectedPanel={setSelectedPanel}
                    wireTransactionType={wireTransactionType}
                    setWireTransactionType={setWireTransactionType}
                    //hifiTransactionType={hifiTransactionType}
                    //setHifiTransactionType={setHifiTransactionType}
                    selectedMethod={selectedMethod}
                    setSelectedMethod={setSelectedMethod}
                    form={form}
                    achForm={achForm}
                  />
                </Col>
              </Row>
            </Col>

            {/* Summary ############################## */}
            <Col span={24} style={{ marginTop: 31 }}>
              <WithdrawSummary
                method={selectedMethod}
                selectedPanel={selectedPanel}
                purchaseData={{
                  pay: { amount: payAmount, setAmount: setPayAmount, type: payType, setType: setPayType },
                  receive: {
                    amount: receiveAmount,
                    setAmount: setReceiveAmount,
                    type: receiveType,
                    setType: setReceiveType,
                  },
                }}
                balance={balance}
                refresh={fetchAccounts}
                fee={fee}
                setFee={null}
                form={form}
                achForm={achForm}
              />
            </Col>
          </>
        )}
        {/*usa == true && process.env.NEXT_PUBLIC_WITHDRAW_ON == 'true' && (
          <Col span={24}>
            <Text>
              We are currently migrating USD withdrawals for all users to our new banking partner. Please monitor your
              email for updates on the migration process and the re-release of this feature. Thanks, Management.
            </Text>
          </Col>
        )*/}
        {process.env.NEXT_PUBLIC_WITHDRAW_ON != 'true' && (
          <Col span={24}>
            <Text>
              Withdrawals are temporarilty turned off. Please monitor your email for updates on the process and the
              re-release of this feature. Thanks, Management.
            </Text>
          </Col>
        )}
      </Row>

      <Spacer value={30} />
    </>
  )
}
